import { render, staticRenderFns } from "./threcord.vue?vue&type=template&id=8c421c2e&"
import script from "./threcord.vue?vue&type=script&lang=ts&"
export * from "./threcord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports